import isNil from 'lodash/isNil';
import { IBuilder, IErrors, IStep } from '../../../../redux/slices/oldBuilder';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { getCohortRowErrorsByQueryType } from '../getCohortRowErrorsByQueryType';
import {
  isEmptyEventCondition,
  isEmptyEventConditions,
} from '../../../../utils/builder';
import { validateTimeWindow } from '../validateExecutionInput';
import { assertCondition } from '../../../../utils/types';

const checkStep = (errors: IErrors, step: IStep, stepIndex: number) => {
  const { eventConditions, negativeSteps } = step;

  if (negativeSteps?.length > 0) {
    negativeSteps.forEach((eventCondition, eventConditionIndex) => {
      if (isEmptyEventCondition(eventCondition)) {
        errors.steps = {
          ...(errors?.steps ?? {}),
          [stepIndex]: {
            ...(errors?.steps?.[stepIndex] ?? {}),
            negativeSteps: {
              ...(errors?.steps?.[stepIndex]?.negativeSteps ?? {}),
              [eventConditionIndex]: true,
            },
          },
        };
      }
    });
  }

  eventConditions.forEach((eventCondition, eventConditionIndex) => {
    if (isEmptyEventCondition(eventCondition)) {
      errors.steps = {
        ...(errors?.steps ?? {}),
        [stepIndex]: {
          ...(errors?.steps?.[stepIndex] ?? {}),
          events: {
            ...(errors?.steps?.[stepIndex]?.events ?? {}),
            [eventConditionIndex]: true,
          },
        },
      };
    }
  });

  return errors;
};

const validateFunnelSteps = (steps: IStep[]): IErrors => {
  const errors: IErrors = {};

  const stepsWithEvents = new Map<number, IStep>();

  steps.forEach((step, stepIndex) => {
    if (!isEmptyEventConditions(step.eventConditions)) {
      stepsWithEvents.set(stepIndex, step);
    }
  });

  if (stepsWithEvents.size === 0) {
    [steps[0], steps[1]].forEach((step, stepIndex) => {
      checkStep(errors, step, stepIndex);
    });
  } else {
    [...stepsWithEvents.entries()].forEach(([stepIndex, step]) => {
      checkStep(errors, step, stepIndex);
    });

    if (stepsWithEvents.size === 1) {
      if (!stepsWithEvents.has(0)) {
        checkStep(errors, steps[0], 0);
      } else if (!stepsWithEvents.has(1)) {
        checkStep(errors, steps[1], 1);
      }
    }
  }

  return errors;
};

const validateFunnelBuilder = (oldBuilderState: IBuilder): IErrors => {
  const errors: IErrors = {
    // validate steps
    ...validateFunnelSteps(oldBuilderState.steps),
    // validate cohorts
    ...getCohortRowErrorsByQueryType(oldBuilderState, QueryType.Funnel),
  };

  const { selectedOptions } = oldBuilderState;

  assertCondition(selectedOptions?.type === QueryType.Funnel);

  // validate timeWindow between 1-365
  if (!isNil(oldBuilderState.timeWindow)) {
    validateTimeWindow(errors, oldBuilderState.timeWindow);
  }
  return errors;
};

export default validateFunnelBuilder;
